import BaseModel from '../BaseModel';

export default class Interviewer extends BaseModel {
  static entity = 'interviewers';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(null).nullable(),
      videoUrl: this.string(null).nullable(),
      photo: this.attr(null),
      videoTimestamps: this.attr([]),
      counts: this.attr({
        questions: 0,
      }),
    };
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get('interviews/interviewers');
      },
    },
  }
}
